import { MenuProps, TabsProps } from 'antd';
import {
  ApprovalAction,
  ApprovalListItemAction,
  ApprovalStatus,
  ApprovalTabs,
  ExportActions,
  SystemProcessHomeAction,
  SystemProcessHomeTabs,
} from '../enums';
import {
  ApprovalLogIcon,
  DeleteIcon,
  EditIcon,
  ViewIcon,
  CopyIcon,
  ProfileIcon,
  UserChangelogView,
} from '../components/ui/GenericMenuIcons';
import { IApprovalButtonActionStatus } from '../types';
import {
  CheckBadgeIcon,
  ClockIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';
import { TravelClaimTabs } from '../enums/tabs';
import {
  PermissionAssignedEdit,
  RoleAssignEdit,
  LockModuleIcon,
  ChangePasswordIcon,
} from '../components/ui/GenericMenuIcons';

export const ADMIN_TYPE_ROLES = ['ADMIN', 'TRAVEL_ADMIN', 'TRAVEL_DESK'];
export const ADMIN_TYPE_ROLES_ONLY = ['ADMIN'];

export const EMPTY_DATA = <span className="text-text-200">-</span>;

export const SYSTEM_PROCESS_HOME_TABS: TabsProps['items'] = [
  { key: SystemProcessHomeTabs.ALL, label: 'All' },
  { key: SystemProcessHomeTabs.DRAFT, label: 'Draft' },
  { key: SystemProcessHomeTabs.SUBMITTED, label: 'Submitted' },
];

export const SYSTEM_PROCESS_APPROVAL_TABS: TabsProps['items'] = [
  {
    key: ApprovalTabs.ALL,
    label: 'All',
  },
  {
    key: ApprovalTabs.PENDING,
    label: 'Pending',
  },
  {
    key: ApprovalTabs.APPROVED,
    label: 'Approved',
  },
  {
    key: ApprovalTabs.HOLD,
    label: 'Hold',
  },
  {
    key: ApprovalTabs.REJECTED,
    label: 'Rejected',
  },
];

export const PROCESS_DRAFT_MENU: MenuProps['items'] = [
  {
    key: SystemProcessHomeAction.VIEW,
    label: <ViewIcon />,
  },
  {
    key: SystemProcessHomeAction.DELETE,
    label: <DeleteIcon />,
  },
  {
    key: SystemProcessHomeAction.COPY,
    label: <CopyIcon />,
  },
];

export const PROCESS_SUBMITTED_MENU: MenuProps['items'] = [
  {
    key: SystemProcessHomeAction.VIEW,
    label: <ViewIcon />,
  },
  {
    key: SystemProcessHomeAction.COPY,
    label: <CopyIcon />,
  },
];

export const PROCESS_SUBMITTED_MENU_FOR_MAPPING: MenuProps['items'] = [
  {
    key: SystemProcessHomeAction.VIEW,
    label: <ViewIcon />,
  },
  {
    key: SystemProcessHomeAction.COPY,
    label: <CopyIcon />,
  },
];

export const USER_ACCESS_CONTROL_MENU: MenuProps['items'] = [
  {
    key: SystemProcessHomeAction.PROFILE_PHOTO,
    label: <ProfileIcon />,
  },
  {
    key: SystemProcessHomeAction.EDIT,
    label: <EditIcon />,
  },
  {
    key: SystemProcessHomeAction.VIEW,
    label: <ViewIcon />,
  },
  {
    key: SystemProcessHomeAction.DELETE,
    label: <DeleteIcon />,
  },
  {
    key: SystemProcessHomeAction.ROLE_ASSIGN,
    label: <RoleAssignEdit />,
  },
  {
    key: SystemProcessHomeAction.PERMISSION_ASSIGN,
    label: <PermissionAssignedEdit />,
  },
  {
    key: SystemProcessHomeAction.VIEW_CHANGELOG,
    label: <UserChangelogView />,
  },
  {
    key: SystemProcessHomeAction.LOCK_MODULE,
    label: <LockModuleIcon />,
  },
  {
    key: SystemProcessHomeAction.CHANGE_PASSWORD,
    label: <ChangePasswordIcon />,
  },
];

export const APPROVAL_MENU_ITEMS: MenuProps['items'] = [
  {
    key: ApprovalListItemAction.VIEW,
    label: <ViewIcon />,
  },
  {
    key: ApprovalListItemAction.APPROVAL_LOG,
    label: <ApprovalLogIcon />,
  },
];

export const TAG_STATUS_TYPE_MAP: Record<ApprovalStatus, string> = {
  [ApprovalStatus.PENDING]: 'processing',
  [ApprovalStatus.APPROVED]: 'success',
  [ApprovalStatus.REJECTED]: 'error',
  [ApprovalStatus.HOLD]: 'warning',
};

export const APPROVAL_BUTTONS_ACTION_STATUS_MAP: Record<
  ApprovalAction,
  IApprovalButtonActionStatus
> = {
  [ApprovalAction.APPROVE]: {
    icon: (
      <CheckBadgeIcon className="size-4 stroke-[2px] font-semibold text-white" />
    ),
    addOnClass: 'bg-success-400',
    label: 'Approve',
  },
  [ApprovalAction.REJECT]: {
    icon: (
      <XCircleIcon className="size-4 stroke-[2px] font-semibold text-white" />
    ),
    addOnClass: 'bg-error-400',
    label: 'Reject',
  },
  [ApprovalAction.HOLD]: {
    icon: (
      <ClockIcon className="size-4 stroke-[2px] font-semibold text-white" />
    ),
    addOnClass: 'bg-warning-400',
    label: 'Hold',
  },
};

export const EXPORT_EXCEL_MENU_ITEMS = [
  {
    key: ExportActions.REPORT_SUMMARY,
    label: 'Report Summary',
  },
  {
    key: ExportActions.CHANGE_LOG,
    label: 'Change Log',
  },
  {
    key: ExportActions.APPROVAL_LOG,
    label: 'Approval Log',
  },
  {
    key: ExportActions.CONVEYANCE_SUMMARY,
    label: 'Conveyance Summary',
  },
  {
    key: ExportActions.HANDSET_SUMMARY,
    label: 'Handset Summary',
  },
  {
    key: ExportActions.EXPENSE_SUMMARY,
    label: 'Expense summary',
  },
  {
    key: ExportActions.CONSOLIDATED_VIEW,
    label: 'Consolidated View',
  },
];

export const TRAVEL_CLAIM_TABS: TabsProps['items'] = [
  { key: TravelClaimTabs.ALL, label: 'All' },
  { key: TravelClaimTabs.REQUEST, label: 'Request' },
  { key: TravelClaimTabs.CLAIM, label: 'Claim' },
];

export const PROCESS_SUBMITTED_MENU_FOR_CONTRACT_MAPPING: MenuProps['items'] = [
  {
    key: SystemProcessHomeAction.VIEW,
    label: <ViewIcon />,
  },
];
